const clients = {
  showroom: {
    clientKey: "showroom", // 🔑 clé utilisée pour backend mutualisé
    name: "Showroom",
    theme: "theme1",
    offer: "Réservation",
    texts: {
      header: {
        hero: "Accueil",
        about: "A Propos",
        menu: "Menu",
        reservation: "Réservation",
        contact: "Contact"
      },
      nav: {
        logo: "https://res.cloudinary.com/dyf8zwvdh/image/upload/v1766598532/le-resto-local/grvhzdzjgssdk6uvcr1w.png",
        order: "Commander",
        reservation: "Réserver",
        login: "Connexion",
        logout: "Déconnexion",
        myAccount: "Mon compte",
        myOrders: "Mes commandes"
      },
      hero: {
        welcome: "Bienvenue chez Showroom",
        subtitle: "",
        title: "",
        button: "Réserver",
        tagline: "En vedette",
        alt: "Visuel de bienvenue"
      },
      about: {
        title: "À propos",
        eyebrow: "Notre histoire",
        subtitle:
          "Une cuisine sincère, des produits sélectionnés, et un service attentionné — l’essentiel pour passer un bon moment.",
        description: "",         // fallback si backend vide
        images: [],              // fallback si backend vide
      
        // ✅ Cartes USP (3 max affichées)
        usps: [
          { icon: "🍳", title: "Cuisine maison", desc: "Préparations soignées, recettes maîtrisées, et un goût constant." },
          { icon: "🥬", title: "Produits frais", desc: "Ingrédients choisis, saisonnalité, et simplicité bien exécutée." },
          { icon: "🤝", title: "Accueil chaleureux", desc: "Une équipe aux petits soins, pour une expérience agréable." }
        ],
      
        // ✅ Trust line (pills)
        trust: {
          items: ["⭐ Avis clients", "🕓 Service rapide", "📍 Sur place & à emporter"]
        },
      
        // ✅ Texte si galerie vide
        emptyGallery:
          "Ajoute quelques photos dans l’admin pour renforcer la confiance."
      },
      menu: {
        title: "Notre carte",
        categories: [
          { key: "entrée", label: "🥗 Entrées" },
          { key: "plat", label: "🍽️ Plats" },
          { key: "dessert", label: "🍰 Desserts" }
        ],
        categoriesTheme6:[],
        items: [],
      },
      
      reservation: {
        title: "Réservez une table",
        name: "Votre nom",
        phone: "Téléphone",
        date: "Date",
        time: "Heure",
        people: "Nombre de personnes",
        service: "",
        email: "Email",
        button: "Réserver",
        success: "✅ Votre réservation a bien été enregistrée !",
        error: "❌ Une erreur est survenue.",
        errorConnection: "❌ Problème de connexion.",
        errorFillAll: "❌ Veuillez remplir tous les champs obligatoires."
      },
      footer: {
        infoTitle: "Infos pratiques",
        address: "25 rue du Devon",
        phone: "0766043001",
        hours: "Lundi 12h-22h",
        email: "memedmax@gmail.com",
        facebookUrl: null,
        instagramUrl: null,
        socialTitle: "Suivez-nous",
        addressTitle: "Adresse",
        contactTitle: "Contact",
        hoursTitle: "Horaires",
        information: "Informations",
        rights: "Tous droits réservés.",
        designedBy: "Design & Dev par Ahmed Max"
      },
      contact: {
        title: "Contactez-nous",
        formTitle: "Envoyer un message",
        name: "Votre nom",
        email: "Votre email",
        message: "Votre message",
        button: "Envoyer",
        success: "✅ Message bien envoyé !",
        error: "❌ Une erreur est survenue.",
        network: "❌ Erreur réseau.",
        address: "25 rue du Devon",
        phone: "0766043001",
        emailText: "memedmax@gmail.com",
        hours: "Lundi 12h-22h"
      }
    }
  }
};

export default clients;